import { useEffect, useState, useMemo } from 'react'
import { curry } from 'ramda'
import { useDispatch } from 'react-redux'

const useApi = (action, initialParam) => {
  const dispatch = useDispatch()
  const [params, setParams] = useState(initialParam)
  const [isLoading, setIsLoading] = useState(false)
  const [doneLoading, setDoneLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      setDoneLoading(false)
      setError(false)

      try {
        if (params !== null) await dispatch(action(params))
      } catch (err) {
        setError(err)
      }

      setIsLoading(false)
      setDoneLoading(true)
    }

    fetchData()
  }, [params, dispatch, action])

  return [{ isLoading, doneLoading, error }, setParams]
}

export default useApi

/**
 This is still semi experimental and should be used when the 
 request will only need to happen once or when changing any of the 
 params should retrigger all requests.
 Ideal for no param gets or single param gets like truck serial.

 ToDo/Maybe Tie params to a particular request, only trigger that request
 when those params change.
 */
export const useMultiApi = (actions, initialParam) => {
  const dispatch = useDispatch()
  const curryDispatch = useMemo(
    () => curry((params, action) => dispatch(action(params))),
    [dispatch]
  )

  const [params, setParams] = useState(initialParam)
  const [isLoading, setIsLoading] = useState(false)
  const [doneLoading, setDoneLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      setDoneLoading(false)
      setError(false)
      try {
        await Promise.all(actions.map(curryDispatch(params)))
      } catch (err) {
        setError(err)
      }

      setIsLoading(false)
      setDoneLoading(true)
    }

    fetchData()
  }, [params, curryDispatch, actions])

  return [{ isLoading, doneLoading, error }, setParams]
}
